import { render, staticRenderFns } from "./thankyou.vue?vue&type=template&id=a5a4cf84&scoped=true&"
import script from "./thankyou.vue?vue&type=script&lang=js&"
export * from "./thankyou.vue?vue&type=script&lang=js&"
import style0 from "./thankyou.vue?vue&type=style&index=0&id=a5a4cf84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a4cf84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\tavo\\source\\repos\\GEG\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a5a4cf84', component.options)
    } else {
      api.reload('a5a4cf84', component.options)
    }
    module.hot.accept("./thankyou.vue?vue&type=template&id=a5a4cf84&scoped=true&", function () {
      api.rerender('a5a4cf84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src\\views\\evaluation\\thankyou.vue"
export default component.exports